import { GET_DROPDOWN_SUCCESS, GET_DROPDOWN_FAILURE } from '../actions';
import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { convertObjectToQueryParams } from 'src/utils/util';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logErrorToConsole } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { dropdowndetails } from 'src/constants/productConstants';

const getURLForDropDown = (
    dropDownName,
    value,
    salesOrg,
    countryISOCode,
    physicianDropdownZGConsignmentBillingVisibility,
    physicianDropdownZGConsignmentAddVisibility,
    physicianDropdownZGSurgeryVisibility,
    physicianDropdownZGReportUsageVisibility,
    accountPhysicianAPIUsage,
    isMastOrder,
    isMastOrderTemplate,
    orderType
) => {
    let url = `/occ/v2/${localStorage.getItem('baseSiteId')}`;
    let cacheAPI = false;

    if (
        value &&
        ((physicianDropdownZGSurgeryVisibility === 'VISIBLE') || (physicianDropdownZGReportUsageVisibility === 'VISIBLE' && accountPhysicianAPIUsage)) &&
        dropDownName === 'physicianList'
    ) {
        dropDownName = 'physicianZGList';
        value.isSurgeryFlow = false;

        if (value.sapPartnerId == '') value.sapPartnerId = '';
    }

    if (
        value &&
        value.hasOwnProperty('sapPartnerId') &&
        physicianDropdownZGConsignmentAddVisibility === 'VISIBLE' &&
        dropDownName === 'physicianList'
    ) {
        dropDownName = 'physicianZGList';
    }

    if (
        value &&
        value.hasOwnProperty('sapPartnerId') &&
        physicianDropdownZGConsignmentBillingVisibility === 'VISIBLE' &&
        dropDownName === 'physicianZGList'
    ) {
        dropDownName = 'physicianZGList';
        value.isSurgeryFlow = false;
    }

    switch (dropDownName) {
        case 'territories':
            url += value
                ? `/aardt/territories?districtCode=${value}`
                : '/aardt/territories';
            break;
        case 'accounts':
            {
                const params = convertObjectToQueryParams(value);
                if (value && value.sapPartnerId) {
                    params.sapPartnerId = value.sapPartnerId; // Add sapPartnerId to params
                }

                url += `/aardt/accounts?${params}${params ? '&' : ''}orderType=${orderType || 'ZLC'}`;
            }
            break;
        case 'accountLookup':
            {
                if (
                    value !== undefined &&
                    value.accountState !== undefined &&
                    value.accountCity === undefined
                ) {
                    url += `/aardt/accountLookup?accountState=${value.accountState}`;
                } else if (
                    value !== undefined &&
                    value.accountState === undefined &&
                    value.accountCity !== undefined
                ) {
                    url += `/aardt/accountLookup?accountCity=${value.accountCity}`;
                } else if (
                    value !== undefined &&
                    value.accountState !== undefined &&
                    value.accountCity !== undefined
                ) {
                    url += `/aardt/accountLookup?accountCity=${value.accountCity}&accountState=${value.accountState}`;
                } else if (
                    value !== undefined &&
                    value.accountName !== undefined
                ) {
                    url += `/aardt/accountLookup?accountName=${value.accountName}`;
                } else {
                    url += '/aardt/accountLookup?';
                }
            }
            break;
        case 'districts':
            {
                url += '/aardt/districts?isOrderCreation=true';
                cacheAPI = false;
            }
            break;

        case 'caseCoverageEmployees':
            {
                const caseParams = convertObjectToQueryParams(value);
                url += `/order/surgery/casesupport?${caseParams}`;
            }
            break;
        case 'procedureList':
            {
                url += '/order/Surgery/procedure';
                cacheAPI = true;
            }
            break;
        case 'physicianList':
            {
                const physicainParmas = convertObjectToQueryParams(value);
                url += `/order/surgery/physician?${physicainParmas}`;
            }
            break;
        case 'mazorCaseCoverageEmployees':
            {
                const mazorParmas = convertObjectToQueryParams(value);
                url += `/aardt/mazorCaseCoverage?${mazorParmas}`;
            }
            break;
        case 'physicianZGList':
            {
                const physicainParmas = convertObjectToQueryParams(value);
                url += `/aardt/accountPhysician?${physicainParmas}`;
            }
            break;
        case 'templates':
            {
                const resourceType = 'ORDER_TEMPLATE_A';
                const templateParams = convertObjectToQueryParams({
                    ...value,
                    resourceType: resourceType,
                    templateType: isMastOrder ? 'ZLC_MAST' : 'ZLC',
                });
                url += `/productTemplates/templateslist?${templateParams}`;
            }
            break;
        case 'billToDetails':
            {
                const caseParams = convertObjectToQueryParams(value);
                url += `/aardt/billtoaccounts?${caseParams}`;
            }
            break;
        default:
            break;
    }
    return { url, cacheAPI };
};
export default function* getDropDown(action) {
    const value = action.payload.value;
    const {
        isMastOrder,
        physicianDropdownZGConsignmentBillingVisibility,
        physicianDropdownZGConsignmentAddVisibility,
        physicianDropdownZGSurgeryVisibility,
        physicianDropdownZGReportUsageVisibility,
        accountPhysicianAPIUsage,
        salesOrg,
        countryISOCode,
    } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder,
        physicianDropdownZGConsignmentBillingVisibility:
            state.loginReducer.physicianDropdownZGConsignmentBillingVisibility,
        physicianDropdownZGConsignmentAddVisibility:
            state.loginReducer.physicianDropdownZGConsignmentAddVisibility,
        physicianDropdownZGSurgeryVisibility:
            state.loginReducer.physicianDropdownZGSurgeryVisibility,
        physicianDropdownZGReportUsageVisibility:
            state.loginReducer.physicianDropdownZGReportUsageVisibility,
        accountPhysicianAPIUsage: state.loginReducer.accountPhysicianAPIUsage,
        salesOrg: state.loginReducer.salesOrg,
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrder: state.commonTemplateReducer.isMastOrderTemplate,
    }));
    let { url, cacheAPI } = getURLForDropDown(
        action.payload.dropDownName,
        action.payload.value,
        salesOrg,
        countryISOCode,
        physicianDropdownZGConsignmentBillingVisibility,
        physicianDropdownZGConsignmentAddVisibility,
        physicianDropdownZGSurgeryVisibility,
        physicianDropdownZGReportUsageVisibility,
        accountPhysicianAPIUsage,
        isMastOrder,
        isMastOrderTemplate,
        action.payload?.orderType ? action.payload.orderType : action.payload?.value?.orderType ? action.payload?.value?.orderType : 'ZLC'
    );
    const isSurgeryPage = action.payload.isSurgeryOrder;
    if (isSurgeryPage && action.payload.dropDownName === 'territories') {
        url += value
            ? `&isSurgeryOrder=${isSurgeryPage}&isOrderCreation=true`
            : `?isOrderCreation=true&isSurgeryOrder=${isSurgeryPage}`;
    }
    try {
        const result = yield axios
            .get(url, { cacheAPI })
            .then((response) => response.data);
        let dropDownResult =
            action.payload.dropDownName === 'accountLookup'
                ? result['accounts']
                : result[action.payload.dropDownName];
        if (action.payload.dropDownName === 'caseCoverageEmployees') {
            if (dropDownResult) {
                dropDownResult = dropDownResult
                    .map((item) => {
                        const caseCoverageName = `${item.caseCoverageFirstName
                            } ${item.caseCoverageLastName
                            } ${accountNumberZeroTrimmer(
                                item.caseCoverageCustomerId
                            )}`;
                        item.caseCoverageFormattedName = caseCoverageName;
                        return item;
                    })
                    .filter((element) => element.caseCoverageEmpId != 'Other');
            }
        } else if (action.payload.dropDownName === 'billToDetails') {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const billToDetailsName = `${item.billToName
                        } ${accountNumberZeroTrimmer(item.billToNumber)}`;
                    item.billToFormattedName = billToDetailsName;
                    return item;
                });
            }
        } else if (
            action.payload.dropDownName === 'accounts' ||
            action.payload.dropDownName === 'accountLookup'
        ) {
            if (dropDownResult) {
                dropDownResult = dropDownResult.map((item) => {
                    const accountName = `${item.accountName
                        } ${accountNumberZeroTrimmer(item.accountId)}`;
                    item.accountFormattedName = accountName;
                    item.filterValue = ` ${item.accountId} ${item.accountName} `;
                    return item;
                });
            }
        } else if (action.payload.dropDownName === 'templates') {
            dropDownResult = result.templateList || [];
        } else if (action.payload.dropDownName === 'physicianList') {
            if (dropDownResult) {
                const excludeOthersPhysicianList = (dropDownResult || []).filter(
                    (item) =>
                        item?.physicianId !== 'sst_phy_other' &&
                        item?.physicianFirstName !== 'Other'
                );

                if (excludeOthersPhysicianList?.length > 0) {
                    dropDownResult =
                        action.payload.value.physicianType === 'All' &&
                            action.payload.value.searchTerm &&
                            action.payload.value.searchTerm != '' &&
                            action.payload.value.templatePk &&
                            action.payload.value.templatePk != ''
                            ? excludeOthersPhysicianList
                                .sort(
                                    (a, b) =>
                                        Number(b.favorite) -
                                        Number(a.favorite)
                                )
                                .map((item) => {
                                    let physicanName = `${item.physicianFirstName} ${item.physicianLastName} ${item.surgeonNumber}`;
                                    if (item?.physicianDisplayName) {
                                        physicanName = `${item.physicianDisplayName
                                            } ${accountNumberZeroTrimmer(
                                               item?.surgeonNumber?item?.surgeonNumber:item.physicianId
                                            )}`;
                                    }
                                    item.physicanFormattedName = physicanName;
                                    item.filterValue = `${item.physicianDisplayName || ''
                                        } ${item.physicianId || ''} ${item.physicianFirstName || ''
                                        } ${item.physicianLastName || ''} ${item.surgeonNumber || ''
                                        }`;
                                    return item;
                                })
                            : excludeOthersPhysicianList.map((item) => {
                                let physicanName = `${item.physicianFirstName} ${item.physicianLastName} ${item.surgeonNumber}`;
                                if (item?.physicianDisplayName) {
                                    physicanName = `${item.physicianDisplayName
                                        } ${accountNumberZeroTrimmer(
                                            item?.surgeonNumber?item?.surgeonNumber:item.physicianId
                                        )}`;
                                }
                                item.physicanFormattedName = physicanName;
                                item.filterValue = `${item.physicianDisplayName || ''
                                    } ${item.physicianId || ''} ${item.physicianFirstName || ''
                                    } ${item.physicianLastName || ''} ${item.surgeonNumber || ''
                                    }`;
                                return item;
                            });
                }
            }
        } else if (
            action.payload.dropDownName === 'mazorCaseCoverageEmployees'
        ) {
            if (dropDownResult) {
                dropDownResult = dropDownResult
                    .map((item) => {
                        const mazorCaseCoverageName = `${item.caseCoverageFirstName
                            } ${item.caseCoverageLastName
                            } ${accountNumberZeroTrimmer(
                                item.caseCoverageCustomerId
                            )}`;
                        item.caseCoverageFormattedName = mazorCaseCoverageName;
                        return item;
                    })
                    .filter((element) => element.caseCoverageEmpId != 'Other');
            }
        }
        const payload = {
            type: GET_DROPDOWN_SUCCESS,
            items: dropDownResult || [],
            name: action.payload.dropDownName,

            statusCode: result.statusCode,
            errorCode: result.errorCode,
            statusMessage: result.statusMessage,
            loadAll: value?.isLoadAll,
        };
        if (action?.payload?.dropDownName === 'procedureList') {
            payload.defaultYesPediatricProcedures = result?.defaultYesPediatricProcedures ? result?.defaultYesPediatricProcedures : '';
            payload.defaultNoPediatricProcedures = result?.defaultNoPediatricProcedures ? result?.defaultNoPediatricProcedures : '';
        }
        yield put(payload);
    } catch (e) {
        // Feature-flagged error logging
        try {
            logErrorToConsole(e);
            logUiErrorToBackend(e, {
                apiEndPoint: url,
                requestPayload: action?.payload || '',
            });
        } catch (logError) {
            logErrorToConsole(logError);
        }
        yield put({
            type: GET_DROPDOWN_FAILURE,
            name: action.payload.dropDownName,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
